import React from 'react';
import { Link } from 'react-router';
import { LetterProcessing } from 'api';
import { API_URL } from 'constants/config';
import { downloadFile } from "constants/downloadFile";
import { connect } from 'react-redux';
import { header } from 'constants/table';
import { Toastr } from 'modules/toastr';
import DataTable from 'components/data-table';
import { msg } from 'constants/message';
import { CheckPermission } from 'modules/login/CheckPermission';
import { FormSearch } from 'modules/handle-letters-old/list-handle-letters-search';
import { RowItemListHandleOldLetters } from 'modules/handle-letters-old/datatable/list';
import { ShowIf } from 'components/utils';
import classnames from 'classnames';
import { isEmpty, get } from 'lodash';

class HandleLettersOld extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: this.props.data,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      advanceSearch: false,
      searchSubmit: false,
      startDateValid: true,
      endDateValid: true,

      searchData: {},
      search: false,
      tableLoading: false,
      searchLoading: false,
      resetFormSearch: false
    };
  }

  async componentDidMount() {
    let state = this.state;
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    state.advanceSearch = data.advanceSearch || false;
    state.pageData.number = data.page || 0;
    state.pageData.size = data.size || 10;
    if (state.advanceSearch) {
      state.searchData.tuKhoa = data.tuKhoa || '';
      state.searchData.nguonDon = data.nguonDon || '';
      state.searchData.maDon = data.maDon || '';
      state.searchData.phanLoaiDon = data.phanLoaiDon || '';
      state.searchData.tinhTrangXuLy = data.trangThaiDonToanHT || '';
      state.searchData.ketQuaXuLy = data.ketQuaToanHT || '';
      state.searchData.startDate = data.tiepNhanTuNgay ? new Date(data.tiepNhanTuNgay) : '';
      state.searchData.endDate = data.tiepNhanDenNgay ? new Date(data.tiepNhanDenNgay) : '';
    }
    await this.setState(state);
    await this.getListData();
    await this.props.dispatch({
      type: 'REFRESH_MENU',
      value: true
    });
  }

  openSearchForm() {
    this.setState({advanceSearch: true});
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    data.advanceSearch = true;
    localStorage.setItem('xldData', JSON.stringify(data));
  }

  closeSearchForm() {
    this.setState({advanceSearch: false});
    let data = localStorage.getItem('xldData') ? JSON.parse(localStorage.getItem('xldData')) : {};
    data.advanceSearch = false;
    localStorage.setItem('xldData', JSON.stringify(data));
  }

  handleDelete(donId) {
    LetterProcessing.actions.deleteDonCu.request({
      id: donId
    }).then(res => {
      Toastr(msg.deleteLetterSucess, 'success');
      this.props.dispatch({
        type: 'REFRESH_MENU',
        value: true
      });
      this.props.dispatch({
        type: 'DELETE_ITEM_DATALIST',
        key: 'listXLD',
        idKey: 'donId',
        id: donId
      });
      this.getListData();
    }).catch(err => {
      let Data = err.response && err.response.data && err.response.data.errors ? err.response.data.errors : [];
      Data.forEach(item => {
        Toastr(item.description, 'error');
      });
    });
  }

  // Note: ThuHoiDon
  handleThuHoi(donId) {
    LetterProcessing.actions.deleteDon.request({
      id: donId
    }).then(res => {
      Toastr(msg.thuHoiDon, 'success');
      this.getListData();
    });
  }

  handleChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  handleChangeTrangThaiXuLyDon(e) {
    this.setState({
      trangThaiXuLyDon: e.target.value,
      advanceSearch: false,
      searchData: {},
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      resetFormSearch: true
    }, () => {
      this.getListData();
    })
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData();
  }

  handleChangePageSize(size) {
    let state = this.state;
    state.pageData.size = size;
    state.pageData.number = 0;
    this.getListData();
    this.setState(state);
  }

  handleSearch(searchData, e) {
    let state = this.state;
    state.search = true;
    state.pageData = {
      number: 0,
      size: 10,
      totalElements: 0
    };
    if (!state.advanceSearch) {
      searchData = {
        tuKhoa: searchData.tuKhoa
      }
    }
    state.searchData = searchData;
    this.getListData();
    this.setState(state);
  }

  async getListData() {
    let params = {
      thanhLapDon: true,
      page: this.state.pageData.number,
      size: this.state.pageData.size,
    }

    this.setState({
      searching: true,
      tableLoading: true,
      searchLoading: true,
      resetFormSearch: false
    });

    if (this.state.searchData.tuKhoa) {
      params.tuKhoa = this.state.searchData.tuKhoa;
    }

    if (this.state.advanceSearch) {
      if (this.state.searchData.nguonDon) {
        params.nguonDon = this.state.searchData.nguonDon;
      }

      if (this.state.searchData.phanLoaiDon) {
        params.phanLoaiDon = this.state.searchData.phanLoaiDon;
      }

      if (!isEmpty(this.state.searchData.loaiThongTinDon)) {
        params.loaiThongTinDon = get(this.state, 'searchData.loaiThongTinDon')
      }
    }
    
    await LetterProcessing.actions.getDonCusInfo.request(params).then(res => {
      if (this.refs.listXLD) {
        let Data = [];
        if (res.data._embedded) {
          Data = res.data._embedded.donCus;
          this.setState({pageData: res.data.page});
        } else {
          this.setState({
            pageData: {
              number: 0,
              size: 10,
              totalElements: 0
            },
          });
        }
        this.setState({
          tableLoading: false,
          searchLoading: false,
          searching: false,
          search: false
        }, ()=> {
          this.props.dispatch({type: 'UPDATE_DATALIST', key: 'listXLD', data: Data});
        });
      }
    }).catch(err => {
      this.setState({
        tableLoading: false,
        searchLoading: false,
        searching: false,
        search: false
      });
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.data !== this.props.data) {
      this.setState({data: this.props.data});
      this.forceUpdate();
    }
  }

  handleExport() {
    const { tuKhoa, phanLoaiDon, loaiThongTinDon, nguonDon } = this.state.searchData;
    let URL = `${String(API_URL)}/donCus/xuatExcel?thanhLapDon=true`
    if (!isEmpty(tuKhoa)) {
      URL = `${URL}&tuKhoa=${tuKhoa}`;
    }
    if (this.state.advanceSearch) {
      if (!isEmpty(phanLoaiDon)) {
        URL = `${URL}&phanLoaiDon=${phanLoaiDon}`;
      }
      if (!isEmpty(loaiThongTinDon)) {
        URL = `${URL}&loaiThongTinDon=${loaiThongTinDon}`;
      }
      if (!isEmpty(nguonDon)) {
        URL = `${URL}&nguonDon=${nguonDon}`;
      }
    }
    downloadFile(URL);
  }

  render() {
    return (
      <div ref="listXLD">
        <div className="center reception-container">
          <div className="top-content right-button">
            <ShowIf condition={CheckPermission('DONCU_THEM')}>
              <div className="right-content">
                <Link className="btn-green" to="/xu-ly-don-cu/them-moi"><i className="tt tt-addfile"></i>Thêm mới</Link>
              </div>
            </ShowIf>
          </div>
          <div className="bottom-content">
            <div className={classnames({
              'search-container super-search': this.state.advanceSearch,
              'search-container': !this.state.advanceSearch
            })}>
              <FormSearch exceptNguonDon="GIAO_TTXM,GIAO_KTDX,TRUC_TIEP,CHUYEN_DON,GIAO_TDTH" advanceSearch={this.state.advanceSearch} onCancel={this.closeSearchForm.bind(this)} handleSearch={this.handleSearch.bind(this)} disabled={ this.state.searching } search={ this.state.search } resetForm={this.state.resetFormSearch} />
              <Link className="rearch-text" onClick={this.openSearchForm.bind(this)}><i className="tt tt-super-search"></i>Tìm kiếm nâng cao</Link>
            </div>
            <DataTable header={header.listXLDC}
              dataList={this.state.data}
              searchData={this.state.searchData}
              pageData={this.state.pageData}
              hideButtonExport
              thanhTra
              handleExport={this.handleExport.bind(this)}
              exporttext="Xuất Excel"
              parent={this}
              search={this.state.search}
              redux={this}
              tableLoading={this.state.tableLoading}>
              <RowItemListHandleOldLetters
                getListData={this.getListData.bind(this)} />
            </DataTable>
          </div>
        </div>
      </div>
    );
  }
}

HandleLettersOld.defaultProps = {
  data: []
}

function bindStateToProps(state) {
  return {
    data: state.dataList.data.listXLD,
    nguoiDungDon: state.formDataTiepCongDan.nguoiDungDon
  };
}

export default connect(bindStateToProps)(HandleLettersOld);



// WEBPACK FOOTER //
// ./src/components/modules/handle-letters-old/list-handle-letters-old/HandleLettersOld.jsx